export default {
    data() {
        return {
            acceptedCookiesUseKey: 'acceptedCookiesUse',
            acceptedExternalCookiesUseKey: 'acceptedExternalCookiesUse',
        }
    },
    methods: {
        deleteAllCookies() {
            this.deleteScriptTags()
            this.hideChatWidget()
            this.clearCookiesData()
        },
        deleteScriptTags() {
            const scripts = document.getElementsByTagName('script')
            Array.from(scripts).forEach(element => {
                element.remove()
            })
        },
        hideChatWidget() {
            const widget = document.getElementById('md-app-widget')
            if (!widget) {
                return
            }
            widget.remove()
        },
        clearCookiesData() {
            setInterval(() => {
                const cookies = document.cookie.split(';')
                if (cookies.length <= 0) {
                    clearInterval()
                    return
                }
                cookies.forEach(cookie => {
                    const eqPos = cookie.indexOf('=')
                    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
                    document.cookie =
                        name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT'
                })
            }, 30000)
        },
    },
}
